import { axios } from "../common";
import jwtDecode from "jwt-decode";
import { IsAuthenticated } from "../middlewares/auth";

const getMultiLang = async () => {
  try {
    const { data } = await axios.get(`AllDictionary`, {
      headers: {
        MappedState: 1,
      },
    });
    return data;
  } catch (err) {
    return err;
  }
};
export const logout = async () => {
  try {
    const token = localStorage.getItem("token");
    const payload = { Token: token, IsMobile: false };
    const data = await axios.post("/logout", payload);
    localStorage.removeItem("token");
    localStorage.removeItem("RoleDetail");
    localStorage.removeItem("multiLang");
    localStorage.removeItem("locale");
    localStorage.removeItem("theme");
    return data;
  } catch (err) {
    // console.log(err);
    return err;
  }
};

export const getRoleDetails = async (token) => {
  try {
    const { nameid: RoleOid } = jwtDecode(token);
    const { data: RoleDetail } = await axios.get(`RoleDetail`, {
      params: {
        $expand: "Navigation,Role",
        $filter: `Role/Oid eq ${RoleOid}`,
      },

      headers: {
        MappedState: 1,
      },
    });
    return RoleDetail.value;
  } catch (err) {
    // console.log(err)
    return err;
  }
};
const getNecessaryData = async (token) => {
  const RoleDetail = await getRoleDetails(token);
  const multiLang = await getMultiLang();
  return { RoleDetail, multiLang };
};

export async function signIn(UserName, StoredPassword) {
  const payload = { UserName, StoredPassword };
  try {
    const { data } = await axios.post("/login", payload, {
      headers: {
        pushToken: localStorage.getItem("firebaseToken"),
        MappedState: 1,
      },
    });
    
    // Xử lý khi data null
    if (!data) {
      const locale = localStorage.getItem('locale') || 'vi';
      let authFailedMessage = "Authentication failed";
      
      if (locale === 'vi') {
        authFailedMessage = "Xác thực thất bại";
      } else if (locale === 'ja') {
        authFailedMessage = "認証に失敗しました";
      }
      
      return {
        isOk: false,
        message: authFailedMessage,
      };
    }

    axios.defaults.headers["token"] = `Bearer ${data.token}`;
    // console.log(axios.defaults.headers.common);
    localStorage.setItem("token", data.token);
    const { RoleDetail, multiLang } = await getNecessaryData(data.token);

    const locale = localStorage.getItem("locale") || "vi";
    const theme = localStorage.getItem("theme") || "light";
    localStorage.setItem("locale", locale);
    localStorage.setItem("theme", theme);
    localStorage.setItem("multiLang", JSON.stringify(multiLang));
    localStorage.setItem("RoleDetail", JSON.stringify(RoleDetail));
    return {
      isOk: true,
      data: data,
      isUsingMfa: data.isUsingMfa,
      changePasswordOnFirstLogon: data.changePasswordOnFirstLogon,
    };
  } catch (e) {
    // Xử lý lỗi từ API response
    if (e.response) {
      // Có response từ server (lỗi 4xx, 5xx)
      const errorData = e.response.data;
      
      // Kiểm tra nếu response có format ResponseBase
      if (errorData && typeof errorData === 'object') {
        // Message từ API đã được backend xử lý đa ngôn ngữ dựa trên language header
        const message = errorData.message || errorData.Message || "An error occurred";
        const msgType = errorData.msgType || errorData.MsgType || "error";
        return {
          isOk: false,
          message: message,
          type: msgType,
        };
      }
      
      // Nếu response là string hoặc format khác
      if (typeof errorData === 'string') {
        return {
          isOk: false,
          message: errorData,
          type: "error",
        };
      }
      
      // Lỗi 500 Internal Server Error
      if (e.response.status === 500) {
        // Message từ API đã được backend xử lý đa ngôn ngữ
        const message = errorData?.message || errorData?.Message || "Internal server error. Please try again later or contact administrator.";
        const msgType = errorData?.msgType || errorData?.MsgType || "error";
        return {
          isOk: false,
          message: message,
          type: msgType,
        };
      }
      
      // Các lỗi khác
      const message = errorData?.message || errorData?.Message || `Request failed with status ${e.response.status}`;
      const msgType = errorData?.msgType || errorData?.MsgType || "error";
      return {
        isOk: false,
        message: message,
        type: msgType,
      };
    }
    
    // Lỗi network (không có response từ server)
    if (e.request && !e.response) {
      const locale = localStorage.getItem('locale') || 'vi';
      let networkErrorMessage = "Cannot connect to server. Please check your network connection or contact administrator.";
      
      if (locale === 'vi') {
        networkErrorMessage = "Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối mạng hoặc liên hệ quản trị viên.";
      } else if (locale === 'ja') {
        networkErrorMessage = "サーバーに接続できません。ネットワーク接続を確認するか、管理者にお問い合わせください。";
      }
      
      return {
        isOk: false,
        message: networkErrorMessage,
        type: "error",
      };
    }
    
    // Lỗi khác
    const locale = localStorage.getItem('locale') || 'vi';
    let unknownErrorMessage = "An unknown error occurred";
    
    if (locale === 'vi') {
      unknownErrorMessage = "Đã xảy ra lỗi không xác định";
    } else if (locale === 'ja') {
      unknownErrorMessage = "不明なエラーが発生しました";
    }
    
    return {
      isOk: false,
      message: e.message || unknownErrorMessage,
      type: "error",
    };
  }
}

export async function GetUser(payload) {
  const token = localStorage.getItem("token") || payload;
  const {
    jti: EmployeeUserOid,
    message,
    EmployeeName,
    EmployeeCode,
    EmployeeOid,
    EmployeeLevel,
    sub: UserName,
    Queryable,
    IsDeclarant,
    IsAllowRegOvt,
  } = IsAuthenticated(token);

  if (!message || !EmployeeUserOid) {
    return {
      isOk: false,
      message: message,
    };
  }
  try {
    if (EmployeeUserOid === "12345678-0000-0000-0000-000000000000") {
      const payload2 = {
        EmployeeCode,
        EmployeeName,
        EmployeeOid,
        EmployeeUserOid,
        EmployeeLevel,
        UserName,
        IsDeclarant,
        Queryable,
        IsAllowRegOvt,
      };
      return {
        isOk: true,
        data: payload2,
      };
    }
    const { data } = await axios.get(`User(${EmployeeUserOid})`, {
      headers: {
        MappedState: 1,
      },
    });
    const payload = {
      ...data,
      EmployeeCode,
      EmployeeName,
      EmployeeOid,
      EmployeeUserOid,
      EmployeeLevel,
      UserName,
      Queryable,
      IsDeclarant,
      IsAllowRegOvt,
    };
    return {
      isOk: true,
      data: payload,
    };
  } catch (e) {
    // console.log('getUser', e)
    return {
      isOk: false,
    };
  }
}
export async function callQueryable(req) {
  try {
    const payload = {
      UserName: req.UserName,
      StoredPassword: req.UserName,
      EmployeeOid: req.employeeOid,
    };
    const { data } = await axios.post("CallQueryable", payload);
    localStorage.setItem("token", data.token);
    axios.defaults.headers.common = { token: `Bearer ${data.token}` };
    const { RoleDetail, multiLang } = await getNecessaryData(data.token);

    const locale = localStorage.getItem("locale") || "vi";
    const theme = localStorage.getItem("theme") || "light";
    localStorage.setItem("locale", locale);
    localStorage.setItem("theme", theme);
    localStorage.setItem("multiLang", JSON.stringify(multiLang));
    localStorage.setItem("RoleDetail", JSON.stringify(RoleDetail));
    return {
      isOk: true,
      data: data,
    };
  } catch (error) {
    // console.log(error)
    return error;
  }
}
export async function createAccount(username, password) {
  try {
    // Send request
    console.log(username, password);

    return {
      isOk: true,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to create account",
    };
  }
}

export async function changePassword(userName, oldPassword, newPassword) {
  const payload = {
    userName,
    oldPassword,
    newPassword,
  };
  try {
    // Send request
    const { data } = await axios.post("/change_password", payload);
    return {
      isOk: true,
      data: data,
      message: "Password changed successfully",
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to change password",
    };
  }
}
export async function recoveryPassword(password, recoveryCode) {
  const payload = {
    Password: password,
    RecoveryCode: recoveryCode,
  };
  try {
    // Send request
    const data = await axios.post("/recovery_password", payload);
    // console.log(payload);
    return {
      isOk: true,
      data: data,
      message: "Password changed successfully",
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to change password",
    };
  }
}
export async function validateRecoveryCode(recoveryCode) {
  try {
    // Send request
    const data = await axios.get("/RecoveryPass", {
      params: {
        recoveryCode: recoveryCode,
      },
    });
    // console.log(payload);
    return {
      isOk: true,
      data: data,
    };
  } catch {
    return {
      isOk: false,
    };
  }
}

export async function resetPassword(email) {
  try {
    // Send request
    const data = await axios.post("/reset_password?email=" + email);
    return {
      isOk: true,
      data: data,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to reset password",
    };
  }
}
export async function resetUser(payload) {
  try {
    // Send request
    const data = await axios.post("/reset_user", payload);
    return {
      isOk: true,
      data: data,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to reset password",
    };
  }
}
